<style>
.blocked{width: 90vw;height:10vw;margin: 0 auto;}
.times{float: left;line-height: 10vw;font-size: 4vw;}
.history{float: right;}
.history button{outline: none;border:0;background-color: rgb(252, 213, 53);height: 8vw;line-height: 8vw;;
border-radius: 8vw;padding: 0 4vw;}
.msg{width: 90vw;margin: 0 auto;}
.msg p{font-size:4vw;line-height: 5vw;text-indent: 4vw;margin-top: 4vw;color: #c99400;}
.mengban{width: 100vw;height: 100vh;background-color: rgba(0, 0, 0, .5);position: fixed;top:0;z-index: 9999;}
.lottery_his{width:90vw;margin: 0 auto;background-color: #fff;height: 105vw;margin-top: 10vw;border-radius: 3vw;
}
.lottery_head{width: 100%;height: 10vw;}
.lottery_head span{display: block;width: 50vw;float: left;margin-left: 20vw;text-align: center;line-height: 10vw;
font-size: 4vw;font-weight: bold;}
.lottery_head img{width:6vw;display: block;float: right;margin-right:5vw;margin-top:2.5vw;}
.lottery_his ul{list-style: none;margin: 0;padding: 0;overflow: hidden;height: 92vw;overflow: scroll}
.lottery_his ul li{width:80vw;margin: 0 auto;padding: 0;overflow: hidden;border-bottom:#e7e7e7 dotted 1px;
box-sizing: border-box;}
.lottery_his ul li:last-child{border-bottom: 0;}
.lottery_his ul li span{display: block; height: 10vw;line-height: 10vw;}
.lottery_his ul li span.aa{float: left;font-size: 4vw;color: #717477;}
.lottery_his ul li span.bb{ font-size: 4vw;color:rgb(252, 213, 53) ;font-weight: bold;
text-align: center;}
</style>
<template>
  <div v-if="all_show">
  <headers @new_lang="new_lang($event)" @chain_changed="chain_changed($event)"  @change="toconnect($event)" :chain="chain_id" :address="addr" :connected="connected"></headers>
	<div class="blocked">
    <div class="times">{{$t('home.index69')}}:{{times}}</div>
    <div class="history"><button @click="open_his">{{$t('home.index70')}}</button></div>
  </div>
  <div class="mengban" v-if="show_his">
    <div class="lottery_his">
      <div class="lottery_head">
        <span>{{$t('home.index71')}}</span>
        <img @click="close_his" src="../../../static/images/closed.svg">
      </div>
      <ul>
        <li v-for="item in list"><!-- <span class="aa">{{item.time}}</span> --><span class="bb">{{item.lottery_name}}</span></li>
      </ul>
    </div>
  </div>
   <LuckyWheel
	    ref="myLucky"
	    width="300px"
	    height="300px"
	    :prizes="prizes"
	    :blocks="blocks"
	    :buttons="buttons"
	    @start="startCallback"
	    @end="endCallback"
	  />
    <div class="msg">
      <p v-for="item in lottery_msg">{{item.content}}</p>
    </div>
    <div class="blank"></div>
    <menus :now="now"></menus>
    </div>
</template>

<script>
import menus from '../components/menus.vue'
import { ethers } from 'ethers'
import { connectWallet, disconnectWallet, getAccount, getChainId, getGasPrice, getProvider } from '../../utils/wallet'
import { getAllowance, approveUnlimited, revokeApproval } from '../../utils/erc20'
import headers from '../components/header.vue'
import Qs from 'qs'
export default {
  components: {
    menus,
    headers
  },
  data () {
    return {
      provider: '',
      connected: false,
      chain_id: 56,
      address: '',
      web3: null,
      gas: '',
      addr: '',
      token: '',
      now:0,
      show_his:false,
      lottery_msg:[],
      list:[],
      joined: false,
      times:0,
      all_show:true,
      userAgent2:'',
      userAgent:'',
      blocks: [{ padding: '13px', background: 'rgb(252, 213, 53)' }],
      prizes: [
        { fonts: [{ text: this.$t('home.index61'), top: '10%' }], background: '#e9e8fe' },
        { fonts: [{ text: this.$t('home.index62'), top: '10%' }], background: '#b8c5f2' },
        { fonts: [{ text: this.$t('home.index63'), top: '10%' }], background: '#e9e8fe' },
        { fonts: [{ text: this.$t('home.index64'), top: '10%' }], background: '#b8c5f2' },
        { fonts: [{ text: this.$t('home.index65'), top: '10%' }], background: '#f1f1f1' }
      ],
      buttons: [{
        radius: '35%',
        background: 'rgb(252, 213, 53)',
        pointer: true,
        fonts: [{ text: this.$t('home.index68'), top: '-10px' }]
      }],
	  account: '',
	  loading: false,
	  errMsg: '',
	   walletReady: false,
	   timers:null,
    }
  },
  async created() {
	 // this.ref = this.$utils.getUrlKey('ref')
      await connectWallet()
      this.walletReady = true
    },
  async mounted () {
    if (window.ethereum) {
  	  try {
  		// 尝试静默恢复连接（不弹授权框）
  		const accounts = await window.ethereum.request({ method: 'eth_accounts' })
  		if (accounts.length > 0) {
  		  // 已经授权过，直接恢复 provider
  		  await connectWallet()
  		}
  	  } catch (e) {
  		console.log('恢复连接失败', e)
  	  }
  	} 
	this.timers = setInterval(() => {
	    if (!this.connected) {
	        this.getAddress()
	    } else {
			 clearInterval(this.timers)
		}
	}, 3000)
 
  },
  methods: {
    readEntrance () {
      const entrance_token = localStorage.getItem('entrance_token');
      const _this = this
      const data = {
        address: _this.address,
        token: entrance_token
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/readEntrance',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state == 1) {
          if(data.data.status == 2) {
         //   window.location.href = data.data.url
          } else {
            this.all_show = true
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    new_lang(lang){
      this.prizes[0].fonts[0].text = this.$t('home.index61')
      this.prizes[1].fonts[0].text = this.$t('home.index62')
      this.prizes[2].fonts[0].text = this.$t('home.index63')
      this.prizes[3].fonts[0].text = this.$t('home.index64')
      this.prizes[4].fonts[0].text = this.$t('home.index65')
      this.buttons[0].fonts[0].text = this.$t('home.index68')
    },
    // 点击抽奖按钮会触发star回调
    startCallback () {
      if(this.times <=0 ){
        this.$toast.center(this.$t('home.index67'))
        return
      }
      // 调用抽奖组件的play方法开始游戏

      this.get_prize()
      // 模拟调用接口异步抽奖
      // setTimeout(() => {
      //   // 假设后端返回的中奖索引是0
      //   const index = 1
      //   // 调用stop停止旋转并传递中奖索引
      //   this.$refs.myLucky.stop(index)
      // }, 3000)
    },
    // 抽奖结束会触发end回调
    endCallback (prize) {
      console.log(prize)
    },
    chain_changed (id) {
      this.chain_id = id
      this.getAddress()
    },
    open_his(){
      this.show_his = true
    },
    close_his(){
      this.show_his = false
    },
    async toconnect (val) {
      console.log(val)
      //
      this.getAddress()
    },
    async getAddress () {
	  let Address = getAccount()
	  console.log(111)
	   console.log(Address)
	   this.address = Address
	    console.log(this.chain_id)
      //this.chain_id = await getChainId()
	 // console.log(this.chain_id)
    //  this.gas = await getGasPrice()
     // const chainId_now = parseInt(chainId, 16)
      if (this.chain_id != 56 && this.chain_id != 1) {
        this.$toast.center(this.$t('home.index21'))
      } else {
        const chainIds = localStorage.getItem('chainId');
         if(!chainIds || chainIds == 'undefined'){
          // this.chain_id = this.chain_id
         //  this.usd = 2
		 localStorage.setItem('chainId',this.chain_id);
         }
		 if(Address){
			  this.connected = true
		 }
       
        this.dologin()
      }
    },
    dologin () {
      const _this = this
      const data = {
        address: _this.address,
        ref: _this.ref
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/login',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          this.addr = data.data.addr
          this.token = data.data.token
          if (this.token) {
            this.readEntrance()
            this.get_times()
            this.get_history()
            // this.get_approve()
            // this.get_product()
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    get_lottery_msg () {
      const _this = this
      const data = {
        address: _this.address
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/lottery/get_lottery_msg',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          this.lottery_msg = data.data
        }
      }).catch(error => {
        console.log(error)
      })
    },
    get_times(){
      const _this = this
      const data = {
        token: _this.token
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/lottery/get_times',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          this.times = data.data
        }
      }).catch(error => {
        console.log(error)
      })
    },
    get_history(){
      const _this = this
      const data = {
        token: _this.token
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/lottery/get_history',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          this.list = data.data
        }
      }).catch(error => {
        console.log(error)
      })
    },
    get_prize(){
      const _this = this
      const data = {
        token: _this.token
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/lottery/get_prize',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          this.$refs.myLucky.play()
          this.get_history()
          setTimeout(() => {
            // 假设后端返回的中奖索引是0
            const index = data.data
            // 调用stop停止旋转并传递中奖索引
            _this.$refs.myLucky.stop(index)
            _this.$toast.center( _this.prizes[index].fonts[0].text)

          }, 3000)
        } else{
          this.$toast.center(this.$t('home.index67'))
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>
